import React from 'react';
import { Badge } from '../components/ui/badge';
import { Cookie } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-gradient-to-b from-gray-900 to-gray-800">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: `radial-gradient(circle at 25% 25%, #0066FF 1px, transparent 1px),
                             radial-gradient(circle at 75% 75%, #0066FF 1px, transparent 1px)`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="absolute top-10 right-10 w-32 md:w-64 h-32 md:h-64 bg-[#0066FF]/20 rounded-full blur-3xl" />
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <Badge className="bg-white/10 text-white hover:bg-white/20 border-0 mb-4">
            <Cookie className="w-4 h-4 mr-2" />
            Legal
          </Badge>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-white">
            Cookie Policy
          </h1>
          <p className="text-gray-300">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What Are Cookies?</h2>
          <p className="text-gray-600 mb-6">
            Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our platform.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">Types of Cookies We Use</h2>
          
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Essential Cookies</h3>
          <p className="text-gray-600 mb-4">
            These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt out of these cookies.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">Performance Cookies</h3>
          <p className="text-gray-600 mb-4">
            These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our platform.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">Functionality Cookies</h3>
          <p className="text-gray-600 mb-4">
            These cookies allow our website to remember choices you make (such as your language preference) and provide enhanced, personalized features.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">Marketing Cookies</h3>
          <p className="text-gray-600 mb-6">
            These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">Managing Cookies</h2>
          <p className="text-gray-600 mb-6">
            You can control and manage cookies in various ways. Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites. Please note that disabling cookies may affect the functionality of our platform.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookie Settings by Browser</h2>
          <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
            <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
            <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
            <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
            <li><strong>Edge:</strong> Settings → Privacy & Security → Cookies</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">Updates to This Policy</h2>
          <p className="text-gray-600 mb-6">
            We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
          <div className="bg-gray-50 p-6 rounded-lg">
            <p className="text-gray-700 font-semibold">HRMQore</p>
            <p className="text-gray-600">Email: privacy@hrmqore.com</p>
            <p className="text-gray-600">Phone: 07042050336</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
